<template>
  <ul class="gap-[24px]">
    <li v-for="{ link, label } in links" :key="label">
      <TopbarLink :link="link" :label="label" />
    </li>
  </ul>
</template>
  
<script setup lang='ts'>
import TopbarLink from '@/modules/layout/components/atoms/TopbarLink';

defineProps<{
  links: {
    link: string,
    label: string
  }[]
}>();
</script>
  
